import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { Observable } from 'rxjs';
import { endPoints } from '../api-end-points';

@Injectable({
  providedIn: 'root',
})
export class ImageUploadService {
  constructor(private apiService: ApiCallService) {}

  upload(file: File, imagePath: string): Observable<any> {
    const formdata = new FormData();
    formdata.append('file', file);
    return this.apiService.Post(imagePath, formdata);
  }
  upload_file_on_cdn(file: File, imagePath: string): Observable<any> {
    debugger
    const formdata = new FormData();
    formdata.append('file', file);
    formdata.append('FolderName', 'cdn1/question-images');
    return this.apiService.uploadFileOnCDN(endPoints.UPLOAD_FILE_ON_CDN,formdata,imagePath);
  }
  delete_file_from_cdn(file: File, imagePath: string): Observable<any> {
    const formdata = new FormData();
    formdata.append('file', file);
    return this.apiService.Post(endPoints.DELETE_FILE_FROM_CDN,imagePath, formdata);
  }
}
